import { render, staticRenderFns } from "./xq.vue?vue&type=template&id=04df2ccc&scoped=true"
import script from "./xq.vue?vue&type=script&lang=js"
export * from "./xq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df2ccc",
  null
  
)

export default component.exports